import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: ['./mobile-app.component.css'],
})
export class MobileAppComponent {
  constructor(private titleService: Title, private metaTagService: Meta) {}

  ngOnInit() {
    // Meta Title , Description , keywords
    this.titleService.setTitle(
      'Mobile App Development Company in Dubai | Pro Web '
    );

    this.metaTagService.updateTag({
      name: 'keywords',
      content:
        'mobile app development, mobile app development dubai, mobile app development company',
    });

    this.metaTagService.updateTag({
      name: 'description',
      content:
        'Pro Web excels in mobile app development, transforming visions into digital reality. Our experts craft user-friendly apps tailored to exceed expectations and drive business success.',
    });
  }

  processdata = [
    {
      icon: '/assets/img/servicesdev/process-way/analysis-orange.png',
      heading: 'Analysis and Planning',
      description:
        'Through thorough research and analysis, we meticulously gather comprehensive information on market trends and target audiences. This information forms the foundation for our precise planning, where we strategically determine the technologies and tools required for project execution. Additionally, we define the website layout and modules, ensuring a well-thought-out framework for the development of a feasible website.',
    },

    {
      icon: '/assets/img/servicesdev/process-way/design-orange.png',
      heading: 'Design & Development',
      description:
        "During the design phase, our focus is on wireframing and creating user interfaces that align with the specific requirements of our clients. Our development process is guided by a keen awareness of online market trends, aiming to captivate the audience's attention through thoughtful design and functionality. We strive to create websites that not only meet but exceed customer expectations.",
    },

    {
      icon: '/assets/img/servicesdev/process-way/quality-orange.png',
      heading: 'Quality Analysis ',
      description:
        'Our dedicated Quality Assurance (QA) team conducts continuous testing to guarantee that the websites are devoid of technical errors, critical bugs, and other code-related issues. This rigorous testing process ensures that the developed applications seamlessly serve their intended purpose, delivering a reliable and user-friendly experience.',
    },
    {
      icon: '/assets/img/servicesdev/process-way/deploy-orange.png',
      heading: 'Deployment',
      description:
        'Upon successful resolution of all technical issues identified during the QA phase, we proceed to launch the websites on online platforms. This deployment phase marks the transition from development to the live environment. Throughout this stage, we actively monitor the websites, gaining insights into user interactions and making any necessary adjustments to optimize performance and user experience.',
    },
  ];

  carouselConfig = {
    autoplay: false,
    autoplaySpeed: 0,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  cardsItems = [
    {
      title: 'Native App Development',
      desc: 'Creating two separate mobile applications for Android & iOS enhances the overall performance & reliability of the mobile solution while enabling the support of intricate features. Native apps offer robustness & streamlined API integration. They consistently outshine cross-platform & hybrid mobile applications in the long term. To develop native Android applications, we provide expertise in Kotlin & Java, while for iOS app development, suitable for various Apple devices like iPhone and iPad, we utilize Swift and Objective-C.',
      img: 'assets/img/servicesdev/globe.webp',
      // btnname: 'Explore Native App Development',
      btnurl: 'native-app-development/dubai',
    },
    {
      title: 'React Native Development',
      desc: "React Native application development offers a lot of advantages tailored for both small & large businesses. This process is crafted to cater to your end-to-end development requirements. Our team oversees every aspect, from conceptual design to rigorous testing & final deployment, guaranteeing that your product stands as a benchmark for exceptional app performance . Whether you're an SME or an enterprise, we ensure that your app aligns seamlessly with your goals & market demands, delivering a high-performance solution.",
      img: 'assets/img/servicesdev/globe.webp',
      // btnname: 'Explore React Native Development',
      btnurl: '/react-native-app-development/dubai',
    },
    {
      title: 'Flutter App Development',
      desc: 'Flutter has risen to prominence as the leading cross-platform mobile app development framework. Our Flutter mobile app development services are strategically designed to assist you in establishing a presence across multiple platforms. From identifying the most suitable product-market fit to seamlessly launching your application on various platforms, our team of Flutter developers can assist you in the complete process of designing, developing, testing, & deploying a fully functional Flutter app whether it is Android, iOS, or both.',
      img: 'assets/img/servicesdev/globe.webp',
      // btnname: 'Explore Flutter App Development',
      btnurl: '/flutter-app-development/dubai',
    },
    {
      title: 'Dedicated Team',
      desc: 'For substantial & enduring development endeavors, a dedicated team emerges as the most favorable option. Whether you choose to augment your project with a complete team or individual specialists, the inclusion of seasoned app developers ensures optimal results. The adaptability inherent in this cooperative approach allows you to maintain peak efficiency, even in the event of evolving project requirements. This collaborative model offers the agility required to navigate the changing demands of your development journey.',
      img: 'assets/img/servicesdev/globe.webp',
      // btnname: 'Explore Dedicated Team',
      btnurl: '/hire-dedicated-developers/dubai',
    },
  ];

  cards = [
    {
      icon: '../../assets/img/servicesdev/creativity.svg',
      heading: 'Creativity',
      description:
        'Unparalleled creativity, where innovation & imagination drive extraordinary results.',
    },
    {
      icon: '../../assets/img/servicesdev/teamwork.svg',
      heading: 'Teamwork',
      description:
        'Exceptional teamwork, where collaboration and synergy form the foundation of success',
    },
    {
      icon: '../../assets/img/servicesdev/innovation.svg',
      heading: 'Realtime monitoring',
      description:
        'Urge to innovate, where we consistently push boundaries, fostering creative thinking.',
    },
    {
      icon: '../../assets/img/servicesdev/quality.svg',
      heading: 'Quality',
      description:
        'Commitment to quality, where excellence is the standard, ensuring every deliverable meets the benchmark',
    },
    {
      icon: '../../assets/img/servicesdev/security.svg',
      heading: 'Security',
      description:
        'Security, where safeguarding the assets and data is our utmost priority, backed by advanced technologies.',
    },
    {
      icon: '../../assets/img/servicesdev/trust.svg',
      heading: 'Trust',
      description:
        'We inspire, built on transparency, honesty, and a track record of delivering on our commitments',
    },
  ];

  logo = [
    '/assets/img/servicesdev/mobile-app/Book_my_pet.webp',
    '/assets/img/servicesdev/mobile-app/upside_health_logo.svg',
    '/assets/img/servicesdev/mobile-app/the_discounter_logo.webp',
    '/assets/img/servicesdev/mobile-app/organic_mantra_logo.webp',
  ];

  logo2 = [
    '/assets/img/servicesdev/mobile-app/Book_my_pet.webp',
    '/assets/img/servicesdev/mobile-app/upside_health_logo.svg',
    '/assets/img/servicesdev/mobile-app/the_discounter_logo.webp',
  ];

  taglinearr = [
    'Award Winning App Agency',
    'Optimized Mobile Experience',
    'Trusted App Partners',
    'Optimized Mobile Experience',
    'Trusted App Partners',
    'Award Winning App Agency',
    'Optimized Mobile Experience',
    'Trusted App Partners',
    'Optimized Mobile Experience',
    'Trusted App Partners',
  ];

  data = [
    'acai_logo.webp',
    'upside_health_logo.svg',
    'discounter_logo.webp',
    'book_my_pet_review.webp',
    'om_logo_review.webp',
  ];

  datamobile = [
    'acai_logo.webp',
    'upside_health_logo.svg',
    'book_my_pet_review.webp',
    'om_logo_review.webp',
  ];

  // ----------------------------------------------------------------------------

  portfolioItems = [
    {
      heading: 'Organics Mantra',
      smalltitle: 'Grocery App',
      desc: "The Organics Mantra app successfully facilitated the delivery of naturally produced vegetables,fruits, groceries, and day-to-day items to customers' doorsteps, aligning with their commitment to environmental sustainability and promoting an organic lifestyle that resonates withhealth-conscious individuals.",
      bgimg: '../../assets/img/servicesdev/organic-mantra.webp',
      icon: '../../assets/img/servicesdev/mobile-app/ionic.svg',
      casestudy: '/case-study/organics-mantra',
      heading1: 'Specialists Worked',
      heading2: 'Downloads in Play Store',
      heading3: 'Ratings in App Store',
      specialist: '4+',
      download: '1k+',
      rating: '4.0',
    },
    {
      heading: 'Book My Pet',
      smalltitle: 'Pet Care App',
      desc: 'Bookmypet is a mobile app designed for pet owners to conveniently book various services for their pets. With this app, pet parents can access various services such as Boarding, Day Care, Grooming, training, Veterinary facilities, and more, from all over the UAE. The app offers multiple search filters.',
      bgimg: '../../assets/img/servicesdev/bookmypet.webp',
      icon: '../../assets/img/servicesdev/mobile-app/react-js.svg',
      casestudy: '/case-study/bookmypet',
      heading1: 'Specialists Worked',
      heading2: 'Downloads in Play Store',
      heading3: 'Ratings in App Store',
      specialist: '5',
      download: '1k+',
      rating: '5.0',
    },
    {
      heading: 'Discounter',
      smalltitle: 'Discount & Coupon App',
      desc: 'Discounter app, a cutting-edge shopping solution where we meticulously curated exclusive deals and discounts from top brands, transforming the shopping landscape this user-friendly ensure a seamless and interactive experience for users. From concept to execution.',
      bgimg: '../../assets/img/servicesdev/discounter.webp',
      icon: '../../assets/img/servicesdev/mobile-app/swift.svg',
      casestudy: '/case-study/discounter',
      heading1: 'Specialists Worked',
      heading2: 'Downloads in Play Store',
      heading3: 'Ratings in App Store',
      specialist: '4+',
      download: '10k+',
      rating: '4.1',
    },
    {
      heading: 'Upside Health',
      smalltitle: 'Health & Fitness App',
      desc: "The introduction of the mobile app for Upside Health's 'Sense' feature has significantly transformed the market, enhancing user accessibility and engagement. This innovation empowers individuals to seamlessly monitor and manage their health, fostering a new era of proactive well-being management.",
      bgimg: '../../assets/img/servicesdev/upside.webp',
      icon: '../../assets/img/servicesdev/mobile-app/flutter.svg',
      casestudy: '/case-study/upside-health',
      heading1: 'Specialists Worked',
      heading2: 'Downloads in Play Store',
      heading3: 'Ratings in App Store',
      specialist: '4+',
      download: '4k',
      // download: '4+',
      rating: '4.2',
      // rating: '24/7',
    },
  ];

  faq = [
    {
      title: ' How much does it cost to develop a mobile app in Dubai?',
      des: '<p> The cost of mobile app development in Dubai ranges from AED 30,000 to AED500,000.</p>',
      isActive: false,
    },
    {
      title: 'How do I choose the best app developer in Dubai?',
      des: '<p>When selecting the best app developer in Dubai, consider your specific app requirements, research potential development partners, evaluate their portfolios and expertise, and review pricing and contracts to ensure alignment with your vision and goals.</p>',
      isActive: false,
    },
    {
      title: 'How much does it cost to pay a company to build an app?',
      des: '<p>The cost of developing a simple app with basic functionality ranges from AED10,000 to AED40,000, while more complex apps like social media or e-commerce apps can cost between AED 30,000 and AED 500,000.</p>',
      isActive: false,
    },
    {
      title:
        ' What industries does Pro Web specialize in transforming through mobile apps?',
      des: '<p>Pro Web specializes in transforming e-commerce, travel and hospitality, and healthcare industries through cutting-edge mobile applications.</p>',
      isActive: false,
    },
  ];

  toggleAccordian(event: any, index: any) {
    this.faq.forEach((item, i) => {
      if (i !== index) {
        item.isActive = false;
      }
    });

    // Toggle the clicked item
    this.faq[index].isActive = !this.faq[index].isActive;
  }

  // ---------------------------------------------------------------------------

  mobileStr: string =
    '<h4 class="my-3">Expertise in Android and iOS App Development</h4> <p>Pro Web, a mobile apps development company, specializes in developing high-quality, user-friendly Android and iOS apps tailored to meet the individual requirements of businesses, making us one of the top app developers in the industry.</p> <p>The team at Pro Web leverages their expertise to ensure seamless performance across platforms, thus catering to the diverse needs of Android and iOS device users.</p> <h4>Customized Solutions for Businesses</h4> <p>Pro Web understands that every business is unique and requires customized mobile app solutions to stay ahead of the competition. Offering tailored mobile app solutions, Pro Web aids businesses in reaching their objectives and sustaining competition within their respective industries.</p> <p>One successful example of Pro Web’s customized solutions is the Hamilton Bay booking system app, which provides a comprehensive aquatics program, allowing users to book swimming lessons and view progress. Pro Web’s ability to create specialized mobile apps is a testament to their dedication to excellence and innovation.</p> <h4 class="my-3">Transforming Industries with Mobile Apps</h4> <p>Pro Web is not only a top mobile app development company but also an industry transformer. We specialize in creating cutting-edge mobile applications that revolutionize industries, primarily in the e-commerce, travel and hospitality, and healthcare sectors.</p> <p>Pro Web harnesses the power of mobile technology to assist businesses in thriving and adapting to the rapidly evolving digital landscape.</p> <h5>E-commerce</h5> <p>In the booming e-commerce industry, Pro Web designs applications that facilitate sales and enhance customer satisfaction. One such app is the Reservet app, a wedding planning application that connects users with the finest event spaces, marquee, limousine, and catering services in the United Arab Emirates.</p> <p>The development of innovative e-commerce apps like the Reservet app stands as a testament to Pro Web’s efforts in empowering businesses to succeed in the digital marketplace.</p> <h5>Travel and Hospitality</h5> <p>The travel and hospitality industry is another area where Pro Web’s expertise shines. By developing robust and intuitive travel management mobile applications, Pro Web is enhancing user experiences and streamlining operations for businesses in this sector.</p> <p>Pro Web’s innovative app solutions are contributing to making travel more accessible and enjoyable for users worldwide.</p> <h5>Healthcare</h5> <p>Healthcare is yet another industry that Pro Web is revolutionizing with their mobile app development expertise. Pro Web impacts the healthcare industry significantly by creating applications that enhance patient care and simplify medical operations.</p> <p>With the integration of emerging technologies such as artificial intelligence and machine learning, blockchain technology, and the Internet of Things (IoT), Pro Web is at the forefront of healthcare app development.</p> <h4 class="my-4">Comprehensive Mobile App Development Services</h4> <p>Pro Web offers a comprehensive range of mobile app development services, including native app development, hybrid app development, and UI/UX design, utilizing various mobile app development languages for your mobile app development project.</p> <p>Pro Web guarantees their clients receive top-tier mobile apps, which are tailored to their unique requirements and industry standards, by providing a complete business solution.</p> <h5>Native App Development</h5> <p>Native app development is one of Pro Web’s core services, ensuring seamless performance and user experience on both Android and iOS platforms. Pro Web uses native ios app development techniques to create mobile apps that fully leverage platform-specific features and capabilities, leading to a more engaging user experience.</p> <h5>Hybrid App Development</h5> <p>For businesses looking to reach a wider audience, Pro Web offers hybrid app development services, providing cost-effective, cross-platform solutions.</p> <p>Utilizing hybrid app development techniques, Our team of experts crafts mobile apps deployable as an android or ios app, thus ensuring a uniform user experience across devices.</p> <h5>UI/UX Design</h5> <p>Pro Web’s UI/UX design services are focused on creating visually appealing and user-friendly interfaces that drive engagement and conversions. With an in-house design team of accomplished UI/UX designers, we ensures that every app they develop not only looks great but also provides an intuitive and enjoyable user experience.</p> <p>Our designs are tailored to the needs of the client, taking into account the target audience,</p> <h4 class="my-3">The Pro Web Mobile App Development Process</h4> <p>Our mobile app development process includes the following steps:</p> <ul> <li>Ideation and strategy</li> <li>Design and development</li> <li>Quality assurance and testing</li> <li>Launch and post-launch support</li> </ul> <p>This process is designed to deliver exceptional results every time and ensures a smooth and successful app development journey from start to finish.</p> <h5>Ideation and Strategy</h5> <p>The first phase of Pro Web’s mobile app development process is ideation and mobile strategy, where they work closely with clients to understand their needs, conduct market research, and create a roadmap for app development.</p> <p>This critical step ensures that the final app aligns with the client’s vision and business objectives. </p> <h5>Design and Development</h5> <p>The design and development phase is where Pro Web’s team of expert app developers and designers bring the app to life. By focusing on creating visually appealing and functional apps that meet client requirements and industry standards, Pro Web ensures that their mobile apps stand out in the crowded app marketplace.</p> <h5>Quality Assurance and Testing</h5> <p>Before launching the app, Pro Web conducts rigorous quality assurance and testing to ensure that it is bug-free, secure, and optimized for performance.</p> <p>By meticulously testing each aspect of the app, Pro Web guarantees that their clients receive a flawless and fully functioning mobile application.</p> <h5>Launch and Post-Launch Support</h5> <p>The final stage of Pro Web’s mobile app development process is launch and post-launch support. This includes app deployment, maintenance, and updates to ensure continued success for our clients.</p> <p>Pro Web’s commitment to providing ongoing support ensures that our clients’ apps remain relevant and up-to-date in the ever-evolving app landscape.</p> <h4 class="my-3">Embracing Emerging Technologies</h4> <p>Pro Web is always at the forefront of technology, embracing emerging technologies such as artificial intelligence, blockchain, and IoT to create cutting-edge mobile apps that drive business growth. Staying ahead of the curve and integrating the latest technological advancements, Pro Web delivers innovative and resilient solutions for businesses through their mobile app development process.</p> <p>Our mobile app development process is designed to ensure that businesses get the most out of</p> <h5>Artificial Intelligence and Machine Learning</h5> <p>Pro Web integrates AI and ML technologies into their mobile apps, automating tasks, improving efficiency, and providing personalized user experiences.</p> <p>Pro Web hones the power of artificial intelligence and machine learning to develop not just smarter but more intuitive mobile apps, thus proving them to be invaluable tools for businesses.</p> <h5>Blockchain Technology</h5> <p>Leveraging blockchain technology, Pro Web creates secure, transparent, and decentralized mobile app solutions for businesses.</p> <p>Implementing blockchain technology in mobile app development, Pro Web ensures data security through a distributed system, thus offering businesses a reliable and trustworthy app solution.</p> <h5>Internet of Things (IoT)</h5> <p>Pro Web utilizes IoT technology to develop connected mobile apps that streamline operations and improve overall business efficiency. Pro Web innovates app creation by integrating IoT devices into their mobile app development process, resulting in apps that simplify operations and provide valuable business insights.</p> <p>Choosing the best mobile app development company in Dubai is no easy task, but with Pro Web’s expertise, dedication to excellence, and innovative approach, your search ends here. Pro Web’s comprehensive mobile app development services, commitment to client satisfaction, and embrace of emerging technologies ensure that they deliver top-notch mobile apps that drive business growth and success.</p> <p>With Pro Web as your mobile app development partner, you can be confident that your app idea will be brought to life with precision, creativity, and technical prowess. Don’t just stay ahead of the competition – dominate the market with a cutting-edge mobile app developed by Pro Web.</p> ';
}
